
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-charts/bubble",
      function () {
        return require("private-next-pages/x/react-charts/bubble.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-charts/bubble"])
      });
    }
  